import { Component, OnInit, OnDestroy } from '@angular/core';
import { ResourceService } from 'src/app/services/resource.service';
import Resource from 'src/app/interfaces/Resource';
import { UserService } from 'src/app/services/user.service';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { UploadService } from 'src/app/services/upload.service';
import { LoadingService } from 'src/app/services/loading.service';
import { ForumService } from 'src/app/services/forum.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { UrlService } from 'src/app/services/url.service';

@Component({
  selector: 'app-add-resource',
  templateUrl: './add-resource.component.html',
  styleUrls: ['./add-resource.component.scss'],
})
export class AddResourceComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  currentUser;
  newResource: Resource = {
    attachment: null,
    approaches: [],
    id: null,
    owner: null,
    ownerMeta: {
      name: null,
      organization: null,
    },
    description: null,
    reactions: [],
    tags: [],
    timestamp: null,
    title: null,
    year: null,
    leadAuthor: null,
    coauthors: [],
    resourceUrl: null,
    resourceMeta: null,
  };
  fromDiscussion = false;
  attachmentFile: File = null;
  attachmentPreviewURL;
  titleFocused: false;
  quillModules = {
    toolbar: [['link', 'bold', 'italic', 'underline', 'strike', 'blockquote', { list: 'ordered' }, { list: 'bullet' }]],
  };
  step = 1;
  tags = {
    standard: [
      'technology',
      'environmental-impacts',
      'governance',
      'markets-finance',
      'funding',
      'cdr-community',
      'social-licensing',
    ],
    approaches: ['microalgae', 'blue-carbon', 'macroalgal','alkalinity', 'co2-removal', 'storage', 'other'],
  };
  coauthorsFocus = [];
  urlError = '';
  discussion;

  constructor(
    private resourceService: ResourceService,
    private userService: UserService,
    private router: Router,
    private uploadService: UploadService,
    private loadingService: LoadingService,
    private route: ActivatedRoute,
    private forumService: ForumService,
    private notificationService: NotificationsService,
    private analyticsService: AnalyticsService,
    private urlService: UrlService
  ) {}

  ngOnInit() {
    this.analyticsService.event('add_resource_view');
    this.subscriptions.add(
      this.userService.user.subscribe((u) => {
        if (u && u.uid) {
          this.currentUser = u;
        }
      })
    );
    this.route.queryParams.subscribe((params) => {
      if (params['discussion']) {
        this.forumService.getDiscussion(params['discussion']).then((d) => {
          this.initDiscussionResource(d);
        });
      }
      if (params['comment']) {
        this.forumService.getComment(params['comment']).then((c) => {
          this.initDiscussionResource(c);
        });
      }
    });
  }
  initDiscussionResource(d) {
    this.discussion = d;
    this.fromDiscussion = true;
    this.newResource.title = this.discussion.prompt ? this.discussion.prompt : '';
    this.newResource.description = this.discussion.content ? this.discussion.content : '';
    // this.newResource.approaches = this.discussion.approaches ? this.discussion.approaches : [];
    // this.newResource.tags = this.discussion.tags ? this.discussion.tags : [];
    this.newResource.attachment = this.discussion.attachment ? this.discussion.attachment : '';
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
  addCoAuthor() {
    this.newResource.coauthors.push('');
    this.coauthorsFocus.push(false);
  }
  next(): void {
    /* Todo: Add some validation */
    if (this.step === 3) {
      this.loadingService.startLoading();
      this.newResource.owner = this.currentUser.uid;
      this.newResource.ownerMeta.name = this.currentUser.displayName;
      this.newResource.timestamp = new Date();
      this.newResource.description = this.urlService.processContent(this.newResource.description);
      if (this.attachmentFile) {
        this.uploadService.uploadFile(this.attachmentFile).then((downloadUrl) => {
          this.newResource.attachment = {
            name: this.attachmentFile.name,
            url: downloadUrl,
          };
          this.createResource();
        });
      } else {
        this.createResource();
      }
    } else {
      this.step++;
      this.analyticsService.event('add_resource_click_next', { step: this.step });
    }
  }
  back() {
    this.step--;
  }
  saveDiscussion(id) {
    this.discussion.resource = id;
    return this.forumService.updateDiscussion(this.discussion.id, this.discussion);
  }
  saveComment(id) {
    this.discussion.resource = id;
    return this.forumService.updateComment(this.discussion.id, this.discussion);
  }
  createResource() {
    this.resourceService.createResource(this.newResource).then(
      (id) => {
        this.notificationService.sendNotifications({
          type: 'newResources',
          author: this.currentUser.uid,
          title: this.newResource.title,
          url: `/resources/${id}`,
        });
        this.analyticsService.event('add_resource_success', {
          approaches: this.newResource.approaches,
          keywords: this.newResource.tags,
        });
        if (this.discussion) {
          this.route.queryParams.subscribe((params) => {
            if (params['discussion']) {
              this.saveDiscussion(id).then(() => {
                this.loadingService.stopLoading();
                this.router.navigate(['/resources/' + id]);
              });
            }
            if (params['comment']) {
              this.saveComment(id).then(() => {
                this.loadingService.stopLoading();
                this.router.navigate(['/resources/' + id]);
              });
            }
          });
        } else {
          this.loadingService.stopLoading();
          this.router.navigate(['/resources/' + id]);
        }
      },
      (e) => console.error(e)
    );
  }

  upload(event): void {
    if (event.target && event.target.files.length > 0) {
      var reader = new FileReader();
      var t = this;
      reader.onload = function (e) {
        t.attachmentPreviewURL = reader.result;
      };
      if (event.target.files[0].name.endsWith('.pdf')) {
        let $img: any = document.querySelector('input[type="file"]');
        reader.readAsArrayBuffer($img.files[0]);
      }
      if (!event.target.files[0].name.endsWith('.pdf')) reader.readAsDataURL(event.target.files[0]); // convert to base64 string

      this.attachmentFile = event.target.files[0];
    }
  }
  removeFile() {
    if (this.attachmentFile) this.attachmentFile = null;
    if (this.newResource.attachment) this.newResource.attachment = null;
  }

  toggleApproach(a): void {
    if (this.newResource.approaches.indexOf(a) === -1) {
      this.newResource.approaches.push(a);
      this.analyticsService.event('add_resource_add_approach', { approach: a });
    } else {
      this.newResource.approaches.splice(this.newResource.approaches.indexOf(a), 1);
    }
  }
  toggleTag(t): void {
    if (this.newResource.tags.indexOf(t) === -1) {
      this.newResource.tags.push(t);
      this.analyticsService.event('add_resource_add_keyword', { approach: t });
    } else {
      this.newResource.tags.splice(this.newResource.approaches.indexOf(t), 1);
    }
  }

  getResourceMeta(url, inputObj) {
    inputObj.isFocused = false;
    if (this.urlService.validURL(url)) {
      this.loadingService.startLoading();
      this.resourceService.getResourceMeta(url).subscribe(
        (res) => {
          this.urlError = '';
          this.newResource.resourceMeta = res;
          this.loadingService.stopLoading();
        },
        (err) => {
          console.error(err);
          this.loadingService.stopLoading();
          // this.urlError = 'There was an error finding this URL.';
        }
      );
    } else {
      this.urlError = 'Please provide a valid URL.';
    }
  }
  clearError() {
    this.urlError = '';
  }

  preventBlur(index) {
    return index;
  }
}
